import React, { Component } from 'react';
import PropTypes from "prop-types";
import { inject, observer } from 'mobx-react';

import Map from "@/components/Map/";
import ILoc from "@/components/ILoc/";
import FloatBtn from "@/components/FloatBtn/";
import BoxLoading from "@/components/BoxLoading/";


import { myFn } from "@/config/";
import * as AllType from "@/utils/dataType";
import { DATA_TYPE_CONFIG } from "@/utils/dataType"; // eslint-disable-line

import "./index.sass";
import "./infoBox.sass";
const { $$ } = myFn;
import { AppStore, DataStore, MapStore } from '@/store/';

// eslint-disable-next-line
import InfoBoxTest from "@/components/test/infoBox/";

@inject(stores => ({
    appStore: stores.appStore,
    dataStore: stores.dataStore,
    mapStore: stores.mapStore,
}))
@observer
class MapWrap extends Component {
    componentDidMount() {
        // 进入 Map 页面了，触发 地图 Store
        const local = localStorage._dataType;
        if (Object.keys(AllType).map(k => AllType[k]).includes(local)) {
            this.props.dataStore.changeType(local);
        } else {
            this.props.dataStore.changeType();
        }
    }

    cacheInfo_refresh = () => {
        history.go(0);
    }
    cacheInfo_close = () => {
        $$("#forCache").remove();
    }
    floatBtnClick = () => {
        history.go(0);
    }
    render() {
        const locState = this.props.appStore.locState;
        const ajaxIsOk = this.props.mapStore.mapPageState.ajax;
        const dataType = this.props.dataStore.dataType;
        const cacheText = this.props.dataStore.cacheTips.text;
        const cacheState = this.props.dataStore.cacheTips.state;
        return (
            <div id="mapAll" data-type={dataType}>
                {
                    cacheState ?
                        <div id="forCache">
                            <div className="box">
                                <span className="content" dangerouslySetInnerHTML={{ __html: cacheText }}></span>
                                <span className="refresh" onClick={this.cacheInfo_refresh}>更新</span>
                                <span className="close" onClick={this.cacheInfo_close}>x</span>
                            </div>
                        </div> : null
                }
                {/* <InfoBoxTest /> */}
                <Map />
                <ILoc {...locState} />
                {/* <button className="mdui-fab mdui-fab-mini mdui-fab-fixed mdui-color-theme-accent mdui-ripple" onClick={this.floatBtnClick} id="floatBtn" >
                    <i className="mdui-icon material-icons">refresh</i>
                </button > */}
                <FloatBtn dataStore={this.props.dataStore} />
                {/* < div id='myCopyRight' >© Powered by < span class='love' >♥</span > && Design by`Very kind of LT`</div > */}
                < div className="mapTips" id="myCopyRight">© Powered by <span className="love">♥</span></div >
                < div className="mapTips dataTypeTips">当前: {DATA_TYPE_CONFIG[dataType] ? DATA_TYPE_CONFIG[dataType].alias : ''}</div >
                {ajaxIsOk ? null : <BoxLoading zIndex="501" />}
            </div >
        );
    }
}
MapWrap.wrappedComponent.propTypes = {
    appStore: PropTypes.instanceOf(AppStore).isRequired,
    dataStore: PropTypes.instanceOf(DataStore).isRequired,
    mapStore: PropTypes.instanceOf(MapStore).isRequired,
};


export default MapWrap;